module.exports = __webpack_public_path__ + "images/referenzen/werbespot/spec_spot_save_your_skin_lux.jpg";